<template>
  <div>
    <div class="imgbox" v-if="value">
      <span>
        <button
          type="button"
          class="button button-error button-sm"
          v-on:click="deleteImg()"
        >
          <svg
            style="margin-top: 4px; width: 12px; height: 12px; fill: #fff"
            x="0px"
            y="0px"
            viewBox="0 0 459 459"
          >
            <g>
              <path
                d="M76.5,408c0,28.05,22.95,51,51,51h204c28.05,0,51-22.95,51-51V102h-306V408z M408,25.5h-89.25L293.25,0h-127.5l-25.5,25.5 H51v51h357V25.5z"
              ></path>
            </g>
          </svg>
        </button>
        <img :src="getImage(value)" />
      </span>
    </div>
    <div class="imgbox" v-else>
      <span>
        <label class="button button-sm button-success">
          <svg
            style="float: left; width: 18px; height: 18px; fill: #fff"
            x="0px"
            y="0px"
            viewBox="0 0 612 612"
          >
            <g>
              <path
                d="M494.7,255C476.85,168.3,400.35,102,306,102c-73.95,0-137.7,40.8-168.3,102C58.65,214.2,0,277.95,0,357 c0,84.15,68.85,153,153,153h331.5c71.4,0,127.5-56.1,127.5-127.5C612,316.2,558.45,260.1,494.7,255z M357,331.5v102H255v-102 h-76.5L306,204l127.5,127.5H357z"
              ></path>
            </g>
          </svg>
          <input
            type="file"
            name="img"
            style="display: none"
            accept="image/jpg, image/jpeg, image/png, image/webp"
            @change="handleUpload()"
          />
        </label>
      </span>
    </div>
  </div>
</template>

<script>
import { del, post, put, get, uploadImage } from "@/helpers/apiRequest";
import { getImage } from "@/helpers/utils";

export default {
  name: "Uploader",
  props: ["value"],
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    getImage: getImage,

    handleUpload() {
      event.preventDefault();
      const settings = {
        el: event.target,
        str: `/image`,
        dim: "100x100",
      };

      this.loading = true;

      uploadImage(settings)
        .then(({ filename }) => {
          this.$emit("input", filename);
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => (this.loading = false));
    },
    deleteImg() {
      this.$swal({
        title: "Confirma Remover ?",
        showCancelButton: true,
        type: "error",
        confirmButtonColor: "#d82727",
      }).then(
        () => {
          this.loading = true;

          del(`/upload/image`, { filename: this.value })
            .then((json) => {
              this.$emit("input", null);
            })
            .catch((err) => {
              console.log(err);
            })
            .finally(() => (this.loading = false));
        },
        () => {}
      );
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Uploader.vue